import React from 'react';

export default ({fill = 'black'}) => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0L0 6L0 18C0 19.1 0.9 20 2 20H14.01C15.11 20 16 19.1 16 18L15.99 2C15.99 0.9 15.1 0 14 0H6ZM1.5 7L7 1.5V7H1.5Z" fill={fill}/>
    </svg>
)